import { getSharedIconBoxStyle } from './shared-icon-box-style';

export const getInfoPaneHeaderStyle = (components, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' } = {}) => ({
  detailHeader: {
    padding: '0 0 16px',
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
  },
  panelTitle: {
    fontFamily: 'Segoe UI',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '27px',
    color: palette.neutralPrimary,
    marginRight: '86px',
    flexGrow: 1,
  },
  iconBox: getSharedIconBoxStyle({ palette }),
  editBox: {
    width: 106,
    marginRight: 8,
  },
  deleteIcon: {
    '&:before': {
      content: '"\\E74D"',
    },
  },
  blueIcon: {
    color: palette.themePrimary,
    fontFamily: iconFontFamily,
    fontSize: '16px',
    lineHeight: '16px',
  },
  headerText: {
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: palette.neutralPrimary,
    marginLeft: '8px',
  },
  disabledButton: {
    color: `${palette.neutralTertiary} !important`,
  },
  editIcon: {
    '&:before': {
      content: '"\\E70F"',
    },
  },
});
